import { Box } from "@chakra-ui/react";
import { useBusinessCompliance } from "contexts/business-compliance-context";

import { Paragraph3 } from "ui/typography";

import { ComplianceTrailTimeline } from "./ComplianceTrailTimeline";

const START_INDEX = 0;
export const ComplianceTrail = () => {
  const { complianceTrails } = useBusinessCompliance();

  return (
    <>
      {complianceTrails.length > START_INDEX ? (
        <ComplianceTrailTimeline complianceTrails={complianceTrails} />
      ) : (
        <Box>
          <Paragraph3
            lineHeight="22.4px"
            textColor="#718096"
          >
            Nothing to see here yet.
          </Paragraph3>
        </Box>
      )}
    </>
  );
};
